import React from "react";

// redux
import { connect } from "react-redux";
import {
  fetchFuelTrackers,
  deleteFuelTracker,
  updateFuelTracker,
  clearFuelTrackerStates,
} from "../../actions/fuelTracker"

// components
import AbstractPage from "../AbstractPage";
import ManagerTable from "../components/managerTable"

import { Type } from 'react-bootstrap-table2-editor';
import Ionicon from "react-ionicons"

class FuelTracker extends AbstractPage {
  constructor(props) {
    super(props);
    this.title = "Fuel Tracker";
    this.state = {
      fuelTrackers: [],
    }

    this.countries = [
      {label:"Australia", value: "Australia"},
      {label:"Brazil", value: "Brazil"},
      {label:"Canada", value: "Canada"},
      {label:"Chile", value: "Chile"},
      {label:"China", value: "China"},
      {label:"England", value: "England"},
      {label:"Finland", value: "Finland"},
      {label:"Ghana", value: "Ghana"},
      {label:"India", value: "India"},
    ]

    this.vehicle = [
      {label:"Hire Vehicle", value: "Hire Vehicle"},
      {label:"Private Vehicle", value: "Private Vehicle"},
      {label:"Third Party Vehicle", value: "Third Party Vehicle"},
    ]

    this.fuelSource = [
      {label:"Service Station", value: "Service Station"},
      {label:"Drum/Tank", value: "Drum/Tank"},
    ]

    this.columns = [
      {
        dataField: 'country',
        text: 'Country',
        headerStyle: {
          width: '100px',
        },
        editor: {
          type: Type.SELECT,
          options: this.countries
        },
        sort: true
      },
      {
        dataField: 'date',
        text: 'Date',
        headerStyle: {
          width: '100px',
        },
        align: "center",
        editor: {
          type: Type.DATE,
        },
        sort: true
      },
      {
        dataField: 'vehicle',
        text: 'Vehicle',
        headerStyle: {
          width: '100px',
        },
        editor: {
          type: Type.SELECT,
          options: this.vehicle
        },
        sort: true
      },
      {
        dataField: 'odometer',
        text: 'Odometer (km)',
        headerStyle: {
          width: '100px',
        },
        align: "center",
        sort: true
      },
      {
        dataField: 'fuel_source',
        text: 'Fuel Source',
        headerStyle: {
          width: '100px',
        },
        editor: {
          type: Type.SELECT,
          options: this.fuelSource
        },
        sort: true
      },
      {
        dataField: 'refuel_location',
        text: 'Refuel Location',
        headerStyle: {
          width: '120px',
        },
        sort: true
      },
      {
        dataField: 'comments',
        text: 'Comments',
        headerStyle: {
          width: '150px',
        },
        sort: true
      },
      {
        dataField: 'delete_button',
        text: '',
        headerStyle: {
          width: '50px',
        },
        align: 'center',
        formatter: this.buttonFormatter.bind(this),
        searchable: false,
      },
    ]
  }

  componentWillMount() {
    if(!this.props.isManager) {
      this.props.history.push("/fuel_tracker")
    }
    this.props.fetchFuelTrackers()
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.fetchSuccess) {
      this.setState({
        fuelTrackers: nextProps.fuelTrackers
      })

      this.props.clearStates()
    }

    if(nextProps.updateSuccess) {
      this.props.clearStates()

      this.props.fetchFuelTrackers()
    }
  }

  buttonFormatter(cell, row, rowIndex) {
    return (
      <a className="cursor-pointer"
        onClick={ () => this.props.deleteFuelTracker(row.id)}
      >
        <Ionicon icon="md-trash" className="sidenav-icon" color="#9d9fa1" />
      </a>
    )
  }

  updateCell(oldValue, newValue, row, column) {
    if(oldValue === newValue) {
      return
    }
    this.props.updateFuelTracker(row.id, row)
  }

  render() {
    return (
      <div className="card-body overflow-auto">
        <ManagerTable
          columns={this.columns}
          data={this.state.fuelTrackers}
          updateCell={this.updateCell.bind(this)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isManager: state.app_token.isManager,
    fetchSuccess: state.fuelTracker.fetchSuccess,
    updateSuccess: state.fuelTracker.updateSuccess,
    fuelTrackers: state.fuelTracker.fuelTrackers,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFuelTrackers: () => {
      dispatch(fetchFuelTrackers())
    },
    deleteFuelTracker: (id) => {
      dispatch(deleteFuelTracker(id))
    },
    updateFuelTracker: (id, data) => {
      dispatch(updateFuelTracker(id, data))
    },
    clearStates: () => {
      dispatch(clearFuelTrackerStates())
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FuelTracker);



// WEBPACK FOOTER //
// ./src/views/manager/FuelTracker.js